import { Icon } from '@toggle/design-system';
import { ScreenerFilter } from '@toggle/toggle';
import clsx from 'clsx';
import React from 'react';

import filterStyles from '~/components/filter/Filter.module.scss';
import { FilterLabel } from '~/components/filter/FilterLabel';
import { FilterUseType } from '~/components/update-filter-options/updateFilterOptions';
import { isFilterWithChildOptionActive } from '~/views/screener/use-screener-store/filter-utils';

import { ActiveFilterOptions } from '../../Filters';
import styles from './FilterTree.module.scss';

export interface FilterTreeProps {
  filter: ScreenerFilter;
  filterOptions: ActiveFilterOptions['options'];
  useType?: FilterUseType;
  showTriggerLabel?: boolean;
  multiselect?: boolean;
  id?: string;
  onClick: () => void;
  isModalOpen?: boolean;
}

export const FilterTree = ({
  filter,
  id = filter.key,
  filterOptions,
  useType,
  multiselect = useType === 'single-use' && filter.config.multiselect,
  showTriggerLabel,
  onClick,
  isModalOpen,
}: FilterTreeProps) => {
  const { name } = filter;
  const isParentOptionActive = isFilterWithChildOptionActive(filterOptions);
  const isFilterActive = useType === 'single-use' && isParentOptionActive;

  return (
    <div>
      <div
        className={clsx(styles.filterTreeTrigger, {
          [styles.active]: isFilterActive,
          [styles.showAsHovered]: isModalOpen,
        })}
        data-filter={id}
        data-testid="tree-filter-trigger"
        role="button"
        onClick={onClick}
      >
        {(showTriggerLabel || !isFilterActive) && (
          <span
            className={filterStyles.triggerLabel}
            data-trigger-label
            data-testid="filter-name"
          >
            {name}
          </span>
        )}
        {isFilterActive && (
          <FilterLabel options={filterOptions} multiselect={multiselect} />
        )}
        <Icon
          iconName="ChevronLightDown"
          size={14}
          fillColor="var(--icon-soft)"
        />
      </div>
    </div>
  );
};
